module.exports = __webpack_public_path__ + "static/img/ediTitleImg.e4a3cd9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/home/ediTitleImg.png
// module id = pHxf
// module chunks = 44